import { gql } from '@apollo/client';
import {
  MeasureFunctionFragment,
  SchemaFieldsFragment,
  UserAliasQueryMeasureFragment,
  VersionFieldsFragment,
} from '../fragments';
import { EventConditionFieldsFragment } from '../events/eventConditions';
import { EntityCategoryFragment } from '../entityCategories';

const RollingControlFragment = gql`
  fragment RollingControlFields on RollingControl {
    function
    window
  }
`;

const MeasureDisplayFormatFragment = gql`
  fragment MeasureDisplayFormatFields on MeasureDisplayFormat {
    kind
    decimalPlace
    calculationUnit
    calculationValue
    unit
  }
`;

const SimpleMeasureFragment = gql`
  fragment SimpleMeasureFields on SimpleMeasure {
    eventConditions {
      ...EventConditionFields
    }
    function {
      ...MeasureFunctionFields
    }
    id
    name
    percentile
    rollingControl {
      ...RollingControlFields
    }
    schema {
      ...SchemaFields
    }
    userAlias {
      ...UserAliasQueryMeasureFields
    }
    version {
      ...VersionFields
    }
    categories {
      ...EntityCategoryFields
    }
    isFavorite
    isManaged
    formula
    varName
    key
    format {
      ...MeasureDisplayFormatFields
    }
  }
  ${EventConditionFieldsFragment}
  ${MeasureFunctionFragment}
  ${UserAliasQueryMeasureFragment}
  ${RollingControlFragment}
  ${SchemaFieldsFragment}
  ${VersionFieldsFragment}
  ${EntityCategoryFragment}
  ${MeasureDisplayFormatFragment}
`;

const CompoundMeasureFragment = gql`
  fragment CompoundMeasureFields on CompoundMeasure {
    id
    name
    rollingControl {
      ...RollingControlFields
    }
    schema {
      ...SchemaFields
    }
    userAlias {
      ...UserAliasQueryMeasureFields
    }
    version {
      ...VersionFields
    }
    categories {
      ...EntityCategoryFields
    }
    isFavorite
    isManaged
    measures {
      ...SimpleMeasureFields
    }
    formula
    key
    format {
      ...MeasureDisplayFormatFields
    }
  }
  ${SimpleMeasureFragment}
  ${RollingControlFragment}
  ${SchemaFieldsFragment}
  ${VersionFieldsFragment}
  ${UserAliasQueryMeasureFragment}
  ${EntityCategoryFragment}
  ${MeasureDisplayFormatFragment}
`;

export const MeasureFragment = gql`
  fragment MeasureFields on Measure {
    ... on SimpleMeasure {
      ...SimpleMeasureFields
    }
    ... on CompoundMeasure {
      ...CompoundMeasureFields
    }
  }
  ${SimpleMeasureFragment}
  ${CompoundMeasureFragment}
`;
